import React, { Component } from "react";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    getUsers,
    setRow,
    setPage,
    removeUser,
    setUserTypeFilter,
    removeCrewUser,
    setProfile,
    getDepartments,
    getAreas,
    setFilterAreaName,
    setLastActive,
    setFilterDepartmentsName,
    setNewUser,
    setUserFilter,
} from "./actions";
import { StyledContent, StyledHeader } from "../../../styles";
import {
    withWidth,
    TablePagination,
    Typography,
    Avatar,
    IconButton,
    List,
    ListItem,
    Grid,
    Button,
    Snackbar,
    SnackbarContent,
    FormControl,
    InputLabel,
    Input,
    InputAdornment,
    FormHelperText,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import DeleteIcon from "@material-ui/icons/Delete";
import AuthIcon from "@material-ui/icons/Build";
import { Modal, ModalBody, ModalFooter, Spinner } from "reactstrap";
import Filters from "./Filters";
import styled from "styled-components";
import Tooltip from '@material-ui/core/Tooltip';
const noImg = require("./imgProfile.png");
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
class UserManagerTableDataWidget extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getAreas();
        props.getDepartments();
        props.setProfile(props.userProfile);
        props.setUserTypeFilter(props.filterByType);
        this.state = {
            showPassword: false,
            password: "",
            removeUserModal: false,
            authUserModal: false,
            authUserInfo: false,
            removeUserInfo: {
                uid: "",
                name: "",
            },
            lastActive: false,
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.filterByType !== prevProps.filterByType) {
            this.props.setUserTypeFilter(this.props.filterByType);
        }
    }
    render() {
        const {
            users,
            row,
            page,
            setRow,
            setPage,
            areas,
            departments,
            setArea,
            width,
            setFilterAreaName,
            setDepartment,
            setFilterDepartmentsName,
        } = this.props;
        return (
            <>
                <Modal
                    isOpen={this.props.requesting}
                    style={{ maxWidth: "00px" }}
                >
                    <ModalBody>
                        {this.props.requesting && (
                            <div
                                style={{
                                    textAlign: "center",
                                    paddingTop: "3em",
                                }}
                            >
                                <div
                                    style={{
                                        background: "white",
                                        width: "fit-content",
                                        display: "inline-block",
                                        padding: "2em",
                                    }}
                                >
                                    <Spinner
                                        style={{
                                            height: 100,
                                            width: 100,
                                            background: "white",
                                        }}
                                        color="primary"
                                    />
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            marginTop: 15,
                                            color: "rgba(0, 0, 0, 0.87)",
                                            fontWeight: "bolder",
                                            fontSize: 20,
                                        }}
                                        variant="body2"
                                    >
                                        Processing...
                                    </Typography>
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>

                {users && (
                    <List style={{ background: "#eee", marginTop: 24 }}>
                        <ListItem
                            style={{
                                width: "100%",
                                background: "white",

                                boxShadow:
                                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                            }}
                        >
                            <div style={{ float: "right" }}>
                                <Filters
                                    areas={areas}
                                    departments={departments}
                                    setArea={setArea}
                                    setAreaType={setFilterAreaName}
                                    setUserFilter={this.props.setUserFilter}
                                    userFilter={this.props.userFilter}
                                    setDepartment={setDepartment}
                                    setDepartmentType={setFilterDepartmentsName}
                                />
                            </div>
                        </ListItem>
                        <ListItem
                            style={{
                                width: "100%",
                                background: "white",

                                boxShadow:
                                    "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                            }}
                        >
                            <div style={{ float: "right" }}>
                                {" "}
                                <TablePagination
                                    colSpan={12}
                                    ActionsComponent={TablePaginationHelper}
                                    count={users.length}
                                    rowsPerPage={row}
                                    page={page}
                                    onChangePage={(event, page) =>
                                        setPage(page)
                                    }
                                    onChangeRowsPerPage={(event) =>
                                        setRow(event.target.value)
                                    }
                                    rowsPerPageOptions={[50, 100]}
                                />
                            </div>
                        </ListItem>
                        <ListItem
                            style={{
                                background: "white",
                                boxShadow:
                                    "0 6px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                            }}
                        >
                            <Grid container spacing={4}>
                                {["xl", "lg"].includes(width) && (
                                    <Grid item sm={12} md={12} lg={1} xl={1}>
                                        <Typography
                                            variant="body2"
                                            style={{ marginLeft: 24 }}
                                        >
                                            <b>Avatar</b>
                                        </Typography>
                                    </Grid>
                                )}
                                {
                                    <Grid item sm={12} md={12} lg={2} xl={2}>
                                        <Typography
                                            variant="body2"
                                            style={{ marginLeft: 24 }}
                                        >
                                            <b>User Details</b>
                                        </Typography>
                                    </Grid>
                                }
                                {["xl", "lg"].includes(width) && (
                                    <Grid item sm={12} md={12} lg={2} xl={2}>
                                        <Typography
                                            variant="body2"
                                            style={{ marginLeft: 24 }}
                                        >
                                            <b>Date Created</b>
                                        </Typography>
                                    </Grid>
                                )}
                                {["xl", "lg"].includes(width) && (
                                    <Grid item sm={1} md={1} lg={4} xl={4}>
                                        <Typography
                                            variant="body2"
                                            style={{
                                                marginLeft: 24,
                                                backgroundColor: this.state
                                                    .lastActive
                                                    ? "#DCDCDC"
                                                    : "#FFFFFF",
                                                paddingLeft: "15px",
                                            }}
                                            onClick={() => {
                                                this.setState({
                                                    lastActive: !this.state
                                                        .lastActive,
                                                });
                                                this.props.setLastActive(
                                                    !this.state.lastActive
                                                );
                                            }}
                                        >
                                            <b>Last Active</b>
                                        </Typography>
                                    </Grid>
                                )}

                                {["xl", "lg"].includes(width) && (
                                    <Grid item sm={1} md={1} lg={2} xl={2}>
                                        <Typography
                                            variant="body2"
                                            style={{ marginLeft: 24 }}
                                        >
                                            <b>Access Level</b>
                                        </Typography>
                                    </Grid>
                                )}
                                {["xl", "lg"].includes(width) && (
                                    <Grid item sm={1} md={1} lg={1} xl={1}>
                                        <Typography
                                            variant="body2"
                                            style={{ marginLeft: 24 }}
                                        >
                                            <b>Actions</b>
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </ListItem>
                        {users.map((e) => {
                            return (
                                <StyledListItem
                                    borderColor={"#0188cc"}
                                    style={{
                                        root: {
                                            borderLeft: "#0188cc",
                                        },
                                    }}
                                >
                                    <Grid container spacing={4}>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={1}
                                            xl={1}
                                        >
                                            <Avatar
                                                src={e.profile_image_url}
                                                style={{
                                                    margin: 12,
                                                    height: 50,
                                                    width: 50,
                                                    marginTop:"25px"
                                                }}
                                                onError={(ev) => {
                                                    ev.target.src = noImg;
                                                }}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={2}
                                            xl={2}
                                            style={{marginTop:"16px"}}
                                        >
                                            <Typography
                                                variant="body2"
                                                style={{ paddingLeft: 24 }}
                                            >
                                                <b>Name: </b>
                                                {e.first_name +
                                                    " " +
                                                    e.last_name}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                style={{ paddingLeft: 24 }}
                                            >
                                                <b>Email: </b>
                                                {e.email}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                style={{ paddingLeft: 24 }}
                                            >
                                                <b>Phone: </b> {e.contact_no}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={2}
                                            xl={2}
                                        >
                                            <Typography
                                                variant="body2"
                                                style={{ padding: 24, marginTop:"13px" }}
                                            >
                                                {e.account_created}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={4}
                                            xl={4}
                                        >
                                            <Typography
                                                variant="body2"
                                            >
                                                {e.last_active_dashboard === "N/A" || typeof e.last_active_dashboard === "undefined" || e.last_active_dashboard === null ?
                                                <Tooltip title="User never logged in to dashboard">
                                                    <img style={{ height: "auto", width: "7%", marginTop: "6px", marginBottom:"7px" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/dashboard_never_logged_in_icon.png")} title="Smiley face"/>
                                                </Tooltip>
                                                    :
                                                <Tooltip title="User last logged in to dashboard">
                                                    <img style={{ height: "auto", width: "7%", marginTop: "6px", marginBottom:"7px" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/dashboard_has_logged_in_icon.png")} title="Smiley face"/>
                                                </Tooltip>
                                                }
                                                &nbsp;&nbsp;<b>Dashboard Last Active:</b> {typeof e.last_active_dashboard === "undefined" ? "N/A" : e.last_active_dashboard }
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                            >
                                                {e.last_active === "N/A" || typeof e.last_active === "undefined" || e.last_active === null ?
                                                    <Tooltip title="User never logged in to App">
                                                        <img style={{ height: "auto", width: "7%", marginTop: "6px", marginBottom:"7px" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/tablet_never_logged_in_icon.png")} title="Smiley face"/>
                                                    </Tooltip>
                                                    :
                                                    <Tooltip title="User last logged in to App">
                                                        <img style={{ height: "auto", width: "7%", marginTop: "6px", marginBottom:"7px"}} alt="tagicon" className="customNameImgStyle" src={require("./icons/tablet_has_logged_in_icon.png")} title="Smiley face"/>
                                                    </Tooltip>
                                                }
                                                &nbsp;&nbsp;<b>App Last Active:</b> {typeof e.last_active === "undefined" ? "N/A" : e.last_active}
                                            </Typography>
                                            
                                        </Grid>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={2}
                                            xl={2}
                                        >
                                            <Typography
                                                style={{
                                                    padding: 24,
                                                    marginTop:"13px"
                                                }}
                                            >
                                                {e.access_level === "Level 0"
                                                    ? "User - Level 0"
                                                    : e.access_level ===
                                                      "Level 1"
                                                    ? "User - Level 1"
                                                    : e.access_level ===
                                                      "Level 2"
                                                    ? "User - Level 2"
                                                    : e.access_level ===
                                                      "Level 3"
                                                    ? "User - Level 3"
                                                    : e.access_level ===
                                                      "Level 4"
                                                    ? "User - Level 4"
                                                    : e.access_level ===
                                                      "Equipment"
                                                    ? "Admin Equipment"
                                                    : e.access_level === "Plant"
                                                    ? "Admin Plant"
                                                    : e.access_level === "User"
                                                    ? "Admin User"
                                                    : e.access_level ===
                                                      "Client"
                                                    ? "Client"
                                                    : e.access_level ===
                                                      "Contractor"
                                                    ? "Contractor"
                                                    : ""}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            sm={12}
                                            md={12}
                                            lg={1}
                                            xl={1}
                                        >
                                            <div
                                                style={{
                                                    padding: 12,
                                                    minWidth: 100,
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <Link
                                                    to={`/user-profile-view/${e.uid}`}
                                                >
                                                    <IconButton
                                                        style={{
                                                            color: "#0188cc",
                                                            // border:
                                                            //     "1px solid #0188cc",
                                                            marginRight: "-17px",
                                                            width:"50%",
                                                            marginTop:"10px"
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Link>
                                                {e.uid.includes("-") ?
                                                <>
                                                    {this.props.canUpdate &&
                                                    e.uid.includes("-") && (
                                                        <IconButton
                                                            onClick={() => {
                                                                this.setState({
                                                                    authUserModal: true,
                                                                    authUserInfo: e,
                                                                });
                                                            }}
                                                            style={{
                                                                color:
                                                                    "#0188cc",
                                                                // border:
                                                                //     "1px solid #0188cc",
                                                                width:"50%",
                                                                marginTop:"10px"
                                                            }}
                                                        >
                                                            <AuthIcon />
                                                        </IconButton>
                                                    )}
                                                </>
                                                :
                                                ""
                                                }
                                                
                                                {this.props.canDelete &&
                                                    e.email.toLowerCase() !==
                                                        "wolf@prowork.ie" && (
                                                        <IconButton
                                                            onClick={() => {
                                                                this.setState({
                                                                    removeUserModal: true,
                                                                    removeUserInfo: {
                                                                        uid:
                                                                            e.uid,
                                                                        name: `${e.first_name} ${e.last_name}`,
                                                                    },
                                                                });
                                                            }}
                                                            style={{
                                                                color: "red",
                                                                // border:
                                                                //     "1px solid red",
                                                                width:"50%",
                                                                marginTop:"10px"
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </StyledListItem>
                            );
                        })}
                    </List>
                )}
                <Modal isOpen={this.state.authUserModal}>
                    <StyledHeader>
                        <Typography variant="h5">
                            Make User Authenticated
                        </Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <Typography variant="body2">
                                Are you you sure you want to transfer
                                <b>
                                    {this.state.authUserInfo
                                        ? this.state.authUserInfo.first_name +
                                          " " +
                                          this.state.authUserInfo.last_name
                                        : ""}
                                </b>{" "}
                                to an authenticated account?
                            </Typography>
                            <Typography variant="body2">
                                <b>
                                    It will permit the user to log in to
                                    dashboard and app pending their access and
                                    security levels have sufficient permissions.
                                </b>
                                <br />
                                Please enter new Password for this user below:
                            </Typography>

                            <FormControl>
                                <div
                                    style={{
                                        border: "2px solid #0188cc",
                                        borderRadius: "9px",
                                    }}
                                >
                                    <InputLabel htmlFor="adornment-password">
                                        &nbsp;&nbsp;Password
                                    </InputLabel>
                                    <Input
                                        autoComplete="off"
                                        id="adornment-password"
                                        style={{ width: "430px" }}
                                        type={
                                            this.state.showPassword
                                                ? "text"
                                                : "password"
                                        }
                                        value={this.state.password}
                                        onChange={(event) => {
                                            this.setState({
                                                password: event.target.value,
                                            });
                                        }}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="Toggle password visibility"
                                                    style={{ float: "right" }}
                                                    onClick={() => {
                                                        this.setState({
                                                            showPassword: !this
                                                                .state
                                                                .showPassword,
                                                        });
                                                    }}
                                                >
                                                    {this.state.showPassword ? (
                                                        <Visibility />
                                                    ) : (
                                                        <VisibilityOff />
                                                    )}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </div>
                                <FormHelperText style={{ color: "black" }}>
                                    Password must contain at least 7 digits
                                </FormHelperText>
                            </FormControl>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() =>
                                    this.setState({
                                        authUserModal: false,
                                        authUserInfo: false,
                                    })
                                }
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.props.setNewUser(
                                        this.state.authUserInfo,
                                        this.state.password,

                                        (success) => {
                                            if (success) {
                                                this.props.removeCrewUser(
                                                    this.state.authUserInfo.uid,
                                                    (success) => {
                                                        if (success) {
                                                            this.setState({
                                                                authSuccess: true,
                                                            });
                                                        } else
                                                            this.setState({
                                                                authFail: true,
                                                            });
                                                    }
                                                );
                                            } else
                                                this.setState({
                                                    authFail: true,
                                                });
                                        }
                                    );

                                    this.setState({
                                        removeUserModal: false,
                                        removeUserInfo: {
                                            uid: "",
                                            name: "",
                                        },
                                        authUserModal: false,
                                        password: "",
                                    });
                                    // this.setState({
                                    //
                                    //     authUserInfo: false
                                    // })
                                }}
                            >
                                Move
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.removeUserModal}>
                    <StyledHeader>
                        <Typography variant="h5">Remove User</Typography>
                    </StyledHeader>
                    <StyledContent>
                        <ModalBody>
                            <Typography variant="body2">
                                Are you you sure you want to remove user{" "}
                                <b>{this.state.removeUserInfo.name}</b>?
                            </Typography>
                            <Typography variant="body2">
                                This will only delete the user from accessing
                                the website and app,{" "}
                                <b>it will not delete this users reports</b>
                            </Typography>
                        </ModalBody>
                    </StyledContent>
                    <ModalFooter>
                        <div>
                            <Button
                                onClick={() =>
                                    this.setState({
                                        removeUserModal: false,
                                        removeUserInfo: {
                                            uid: "",
                                            name: "",
                                        },
                                    })
                                }
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (
                                        !this.state.removeUserInfo.uid.includes(
                                            "-"
                                        )
                                    ) {
                                        this.props.removeUser(
                                            this.state.removeUserInfo.uid,
                                            (success) => {
                                                if (success) {
                                                    this.setState({
                                                        removeSuccess: true,
                                                    });
                                                } else
                                                    this.setState({
                                                        removeFail: true,
                                                    });
                                            }
                                        );
                                    } else {
                                        this.props.removeCrewUser(
                                            this.state.removeUserInfo.uid,
                                            (success) => {
                                                if (success) {
                                                    this.setState({
                                                        removeSuccess: true,
                                                    });
                                                } else
                                                    this.setState({
                                                        removeFail: true,
                                                    });
                                            }
                                        );
                                    }
                                    this.setState({
                                        removeUserModal: false,
                                        removeUserInfo: {
                                            uid: "",
                                            name: "",
                                        },
                                    });
                                }}
                            >
                                Remove
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.removeSuccess || this.state.removeFail}
                    onClose={() => {
                        this.setState({ removeSuccess: false });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.removeSuccess
                                ? "green"
                                : this.state.removeFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.removeSuccess
                                ? "User has been successfully removed!"
                                : this.state.removeFail
                                ? "Unable To Delete User, Please Contact An Admin!"
                                : ""
                        }
                    />
                </Snackbar>
                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={6000}
                    open={this.state.authSuccess || this.state.authFail}
                    onClose={() => {
                        this.setState({ authSuccess: false });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: this.state.authSuccess
                                ? "green"
                                : this.state.authFail
                                ? "red"
                                : "white",
                            color: "white",
                        }}
                        message={
                            this.state.authSuccess
                                ? "User has been successfully given authentication!"
                                : this.state.authFail
                                ? "Unable To User Authentication, Please Contact An Admin!"
                                : ""
                        }
                    />
                </Snackbar>
            </>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const {
                selectUserInfo,
                selectPage,
                selectRow,
                getRequesting,
                selectAreas,
                selectDepartments,
                setAreas,
                setDepartments,
                selectAllUserEmails,
                selectUserFilter,
                selectLastActive,
            } = selectors;
            return {
                users: selectUserInfo(store),
                page: selectPage(store),
                row: selectRow(store),
                requesting: getRequesting(store),
                areas: selectAreas(store),
                departments: selectDepartments(store),
                setArea: setAreas(store),
                setDepartment: setDepartments(store),
                userFilter: selectUserFilter(store),
                user_emails: selectAllUserEmails(store),
                lastActive: selectLastActive(store),
            };
        },
        {
            getUsers,
            setRow,
            setPage,
            removeUser,
            setUserTypeFilter,
            removeCrewUser,
            setProfile,
            getDepartments,
            getAreas,
            setFilterAreaName,
            setFilterDepartmentsName,
            setNewUser,
            setUserFilter,
            setLastActive,
        }
    )(withWidth()(UserManagerTableDataWidget))
);
